import './styles.css';
import { FC } from 'react';
import cn from 'classnames';

interface Props {
  isButton?: boolean;
}

export const Spinner: FC<Props> = ({ isButton }) => (
  <div
    className={cn('lds-ring', { ['small']: isButton }, { ['light']: isButton })}
  >
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);
